import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "../Popup/Popup";


interface Props {
}

interface State {
}

class GreenListHelpPopup extends Component<Props, State> {

	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		return (
			<Popup
				id={ "greenListHelp" }
				modalMainContainer={ "modal fade" }
				modalSubContainer={ "modal-dialog modal-dialog-centered" }
				modalBodyContainer={ "modal-body" }
				title={ Strings.gl_green_list_information }
				showIcon={ false }
			>
				{ Strings.green_list_info }
			</Popup>
		);
	}
}

export default GreenListHelpPopup;
